/**
 * @typedef {import('../../definitions').LeafletPlace} LeafletPlace
 * @typedef {import('leaflet').LatLngTuple} LatLngTuple
 */

/**
 * Extract all places location coordinates for using as map bounds.
 * @param {LeafletPlace[]} places
 * @return {LatLngTuple[]}
 */
export const composePlacesBounds = (places) => {
  if (!places) {
    return []
  }

  return places.map((place) => {
    /**
     * @type {LatLngTuple}
     */
    return [place.latitude, place.longitude]
  })
}
